import React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import AddLocationIcon from '@mui/icons-material/AddLocation';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import useWindowSize from "../utils";

import mappa from "../images/mappa.jpg"

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        minHeight: "680px",
        display: "flex",
        justifyContent: "center",
        overflowX: "hidden",
        // overflowY: "hidden",
    },
    container1: {
        margin: "50px",
        padding: "4%",
    },
    container2: {
        margin: "50px",
        padding: "4%",
        height: "70%",
        border: "5px solid #707070",
        borderRadius: "20px",
        backgroundImage: `url(${mappa})`,
    },
}));

function Contacts() {
    const classes = useStyles();
    const { width } = useWindowSize();
    const xs = width > 550 ? 5 : 12

    return (
        <div className={classes.root}>
            <Grid container spacing={2} >
                <Grid item xs={xs} className={classes.container1} style={{}}>
                    <h1>Contatti</h1>
                    <p>Azienda agricola Morabito è sempre disponibile a soddifare le vostre richieste ai seguenti recapiti:</p>

                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", margin: "5%" }} >
                        <AddLocationIcon style={{ width: "70px", height: "70px", color: "#ffbd2c" }} />
                        <p style={{ marginLeft: "20px" }}>Situati in: <b> Località Mazzacuva, snc, Bova Marina, RC, 89035 </b></p>
                    </div>

                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", margin: "5%" }}>
                        <PhoneIcon style={{ width: "70px", height: "70px", color: "#ffbd2c" }} />
                        <p style={{ marginLeft: "20px" }}>Al numero: <b>3496825991</b></p>
                    </div>

                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", margin: "5%" }}>
                        <EmailIcon style={{ width: "70px", height: "70px", color: "#ffbd2c" }} />
                        <p style={{ marginLeft: "20px" }}>Via email: <b>roccomorabito95@pec.it</b></p>
                    </div>
                </Grid>

                <Grid item xs={xs} className={classes.container2} >
                </Grid>
            </Grid>
        </div>
    );
}

export default Contacts;
